import './index.css' // <- Parcel will bundle this
import { createRoot } from 'react-dom/client'
import App from './App'

import './i18n'

const rootElement = document.getElementById('app')

if (rootElement) {
  const root = createRoot(rootElement)
  root.render(<App />)
} else {
  console.error('Root element not found')
}
